
import Vue from "vue";
export default Vue.extend({
    name: "GuidelineHeading",
    props: {
        level: {
            type: Number,
            required: true
        },
        heading: {
            type: String,
            required: true
        }
    },
    mounted() {
        window.addEventListener("scroll", this.handleSticky);
    },
    methods: {
        handleSticky(){
            const title = document.querySelector(".io-title");
            if (window.innerWidth >= 968 && window.pageYOffset > 200 && !title?.classList.contains("sticky")) {
                title?.classList.add("sticky");
            } else if (window.innerWidth >= 968 && window.pageYOffset < 200 && title?.classList.contains("sticky")) {
                title?.classList.remove("sticky");
            }

            if (window.innerWidth < 968 && window.pageYOffset > 114 && !title?.classList.contains("sticky")) {
                title?.classList.add("sticky");
            } else if (window.innerWidth < 968 && window.pageYOffset < 114 && title?.classList.contains("sticky")) {
                title?.classList.remove("sticky");
            }
        }
    }
});
